// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notes-creation-window {
  width: 800px;
}
.inline-input {
  display: inline-block;
  margin-bottom: -5px;
  margin-top: -7px;
  width: 100%;
}
.inline-input.fixed-width {
  width: 200px;
}
.project-details .form-horizontal label.control-label.text-left {
  font-weight: normal;
}
.project-details .view-mode .form-horizontal label.control-label {
  padding-top: 0;
}
.project-details .dataTables_length {
  margin-top: 5px;
}
.project-details table.dataTable.no-footer {
  margin-top: 10px;
  border-bottom: 1px solid #ddd;
  border-top: 1px solid #ddd;
}
.project-details table.dataTable.no-footer thead {
  background-color: #f4f8fb;
  color: #1a90dc;
  font-weight: 700;
}
.project-details table.dataTable.no-footer thead th {
  text-align: left !important;
  border-bottom: none !important;
  font-size: 13px;
}
.project-details .details-header {
  position: relative;
}
.project-details .details-header .delete-btn {
  position: absolute;
  right: 15px;
  top: 15px;
}
.project-details .big-rows > .row:nth-child(even) {
  background: #F5F5F5;
}
.project-details input.currency {
  text-align: right;
  padding-right: 15px;
}
.project-details .currency-input-group-addon {
  position: absolute;
  height: 100%;
  width: 35px;
  padding-top: 7px;
  padding-left: 14px;
  background: #DDD;
}
.project-details .currency-input-group-addon.result {
  width: 29px;
  padding-top: 7px;
  padding-left: 10px;
}
.project-details .currency-value {
  margin-left: 0px;
}
.projects-tree a.active:not(.child-active) {
  color: black;
  font-weight: bold;
  text-decoration: none;
  cursor: text;
}
.projects-tree a.active:not(.child-active):focus,
.projects-tree a.active:not(.child-active):hover {
  text-decoration: none;
}
.projects-tree .add-project {
  border-radius: 10px;
  margin-right: -8px;
  margin-top: -2px;
}
.projects-tree .fa.fa-file-o,
.projects-tree .fa.fa-folder-o {
  margin-right: 3px;
  font-size: 12px;
}
.projects-tree .main-project {
  font-size: 13px;
  margin-top: 5px;
}
.projects-tree .sub-project {
  position: relative;
  margin-top: 8px;
  margin-bottom: 8px;
}
.projects-tree .sub-project .btn.btn-danger {
  position: absolute;
  right: 0;
}
.projects-tree .sub-project {
  margin-left: 10px;
  font-size: 12px;
}
.projects-tree .btn-xs {
  border-radius: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/projectsManagement/styles/projectsManagement.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;AACd;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;;EAEE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB","sourcesContent":[".notes-creation-window {\n  width: 800px;\n}\n.inline-input {\n  display: inline-block;\n  margin-bottom: -5px;\n  margin-top: -7px;\n  width: 100%;\n}\n.inline-input.fixed-width {\n  width: 200px;\n}\n.project-details .form-horizontal label.control-label.text-left {\n  font-weight: normal;\n}\n.project-details .view-mode .form-horizontal label.control-label {\n  padding-top: 0;\n}\n.project-details .dataTables_length {\n  margin-top: 5px;\n}\n.project-details table.dataTable.no-footer {\n  margin-top: 10px;\n  border-bottom: 1px solid #ddd;\n  border-top: 1px solid #ddd;\n}\n.project-details table.dataTable.no-footer thead {\n  background-color: #f4f8fb;\n  color: #1a90dc;\n  font-weight: 700;\n}\n.project-details table.dataTable.no-footer thead th {\n  text-align: left !important;\n  border-bottom: none !important;\n  font-size: 13px;\n}\n.project-details .details-header {\n  position: relative;\n}\n.project-details .details-header .delete-btn {\n  position: absolute;\n  right: 15px;\n  top: 15px;\n}\n.project-details .big-rows > .row:nth-child(even) {\n  background: #F5F5F5;\n}\n.project-details input.currency {\n  text-align: right;\n  padding-right: 15px;\n}\n.project-details .currency-input-group-addon {\n  position: absolute;\n  height: 100%;\n  width: 35px;\n  padding-top: 7px;\n  padding-left: 14px;\n  background: #DDD;\n}\n.project-details .currency-input-group-addon.result {\n  width: 29px;\n  padding-top: 7px;\n  padding-left: 10px;\n}\n.project-details .currency-value {\n  margin-left: 0px;\n}\n.projects-tree a.active:not(.child-active) {\n  color: black;\n  font-weight: bold;\n  text-decoration: none;\n  cursor: text;\n}\n.projects-tree a.active:not(.child-active):focus,\n.projects-tree a.active:not(.child-active):hover {\n  text-decoration: none;\n}\n.projects-tree .add-project {\n  border-radius: 10px;\n  margin-right: -8px;\n  margin-top: -2px;\n}\n.projects-tree .fa.fa-file-o,\n.projects-tree .fa.fa-folder-o {\n  margin-right: 3px;\n  font-size: 12px;\n}\n.projects-tree .main-project {\n  font-size: 13px;\n  margin-top: 5px;\n}\n.projects-tree .sub-project {\n  position: relative;\n  margin-top: 8px;\n  margin-bottom: 8px;\n}\n.projects-tree .sub-project .btn.btn-danger {\n  position: absolute;\n  right: 0;\n}\n.projects-tree .sub-project {\n  margin-left: 10px;\n  font-size: 12px;\n}\n.projects-tree .btn-xs {\n  border-radius: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
